import { render, staticRenderFns } from "./ListAlert.vue?vue&type=template&id=6ce4e2ed&"
import script from "./ListAlert.vue?vue&type=script&lang=js&"
export * from "./ListAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports